import React from "react";
import { Collapse, Grid, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import DatePickerByPlatform from "../../DatePickerByPlatform";
import SingleSelectDropdown from "../../select/base/SingleSelectDropdown";

const options = [
  { label: "app.contract.column.date.CREATED_AT", value: "CREATED_AT" },
  { label: "app.contract.column.date.ACTIVATION_DATE", value: "ACTIVATION_DATE" },
  { label: "app.contract.column.date.DUE_DATE", value: "DUE_DATE" },
  { label: "app.contract.column.date.ARCHIVE_DATE", value: "ARCHIVE_DATE" },
];

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: theme.spacing(1),
  },
}));

const ContractColumnDateFilter = ({ column, onChangeColumn, startDate, finalDate, onStartDateChange, onFinalDateChange, loading }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        item
        xs={12}
      >
        <SingleSelectDropdown
          title="app.contract.column.date.filter"
          values={options}
          onChange={onChangeColumn}
          defaultSelected={null}
          emptyMessage="app.no.options"
        />
        <Collapse in={!!column}>
          <Grid
            container
            spacing={2}
            className={classes.marginTop}
          >
            <Grid
              item
              xs={12}
              md={6}
              sm={6}
            >
              <DatePickerByPlatform
                value={startDate}
                onChange={onStartDateChange}
                label={<FormattedMessage id="app.date.start" />}
                disabled={loading}
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sm={6}
            >
              <DatePickerByPlatform
                value={finalDate}
                onChange={onFinalDateChange}
                label={<FormattedMessage id="app.date.final" />}
                disabled={loading}
                size="small"
              />
            </Grid>
          </Grid>
        </Collapse>
      </Grid>
    </>
  );
};

export default ContractColumnDateFilter;
